export const AUTH_STORAGE_KEY = 'guru-cms-auth'
export const REGISTRATION_TYPE_STORAGE_KEY = 'guru-cms-register-type'
